import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { ArcRoutes } from '../../pages/arc/constants/routes';
import { TcsmStates } from '../../root/tcsm-model';
import { GenerateInstitutionQuickNavMenu, NavOverwrites } from '../constants/navigation-lists';
import { isDioAdmin } from '../helpers/auth-helpers';
import { useBasePath } from '../hooks/useBasePath';
import { TcsmSiteSettingsProps } from '../models/epi-model';
import { DropdownNavigation } from './dropdown-navigation';

export interface Props {
	basePath: string;
}

export const InstitutionNav = (props: Props) => {

	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state.epiProps?.siteSettingsState?.siteSettings);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const institutionCn = useSelector<TcsmStates, string>(state => state?.institutionState?.institutionClientNumber);
	const isDiocesan = isDioAdmin(institutionCn);
	const overwrite: NavOverwrites = { matchPath: ArcRoutes.ReportsDiocesan, overwritePath: useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.ReportsDiocesan}`), hide: !isDiocesan };
	const navOptions = GenerateInstitutionQuickNavMenu(props.basePath, language, siteSettings, [overwrite]);
	const location = useLocation();

	const pathName = location.pathname.toLocaleLowerCase();

	if (!navOptions.some(a =>
		(a.value?.length > 0 && pathName.includes((a.value?.toLocaleLowerCase()))) ||
		(a.fallbackMatch?.length > 0 && pathName.includes(a.fallbackMatch?.toLocaleLowerCase())))) {
		return null;
	}

	return (
		<DropdownNavigation options={navOptions} />
	);
};